import { ConsultationFormData } from '../components/consultation/ConsultationForm';
import { supabase } from './supabase';
import { sendTelegramNotification } from './telegram';

export async function submitConsultation(data: ConsultationFormData) {
  try {
    // First store in Supabase
    const { data: emailData, error: emailError } = await supabase.from('emails').insert({
      name: data.name,
      email: data.email,
      message: `
Consultation Request

Name: ${data.name}
Email: ${data.email}
Company: ${data.company || 'N/A'}
Phone: ${data.phone || 'N/A'}
Preferred Date: ${data.preferredDate}
Preferred Time: ${data.preferredTime}
Timezone: ${data.timezone}

Message:
${data.message}
      `
    }).select().single();

    if (emailError) throw emailError;

    // Store the selected solution if provided
    if (data.selectedSolution && emailData) {
      const { error: solutionError } = await supabase.from('solutions').insert({
        email_id: emailData.id,
        solution_name: data.selectedSolution
      });

      if (solutionError) throw solutionError;
    }

    // Send Telegram notification
    await sendTelegramNotification(data);

    return { success: true };
  } catch (error) {
    console.error('Error submitting consultation:', error);
    throw error;
  }
}